import { useEffect, useState } from "react";
import { Shop } from "../../types/Shop";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

type Options = {
  communityId?: string;
};

export const useAllShops = ({ communityId }: Options = {}) => {
  const [shops, setShops] = useState<Shop[]>([]);

  useEffect(() => {
    if (!communityId) {
      setShops([]);
      return;
    }

    const docRef = firestore
      .collection(DB_PATH.COMMUNITY)
      .doc(communityId)
      .collection("Shop")
      .doc("shop");

    const unsubscribe = docRef.onSnapshot(
      (doc) => {
        if (doc.exists) {
          const data = doc.data() as Shop;
          setShops([{ ...data, id: communityId }]);
        } else {
          setShops([]);
        }
      },
      (error) => {
        console.error("Error fetching shop", error);
        setShops([]);
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return shops;
};
